/**
 * A ledger file without what sync added to it (`_sync_*` tables, capture
 * triggers): what an encrypted org's copy becomes when it leaves sync — for a
 * ledger encrypted on this device, or the server's plain one. Done on a copy in
 * memory (sql.js), so the file sync keeps is untouched until the move is over.
 */
import { remove } from 'tenantdb/sync'
import { asRollbackFile } from 'tenantdb/move'

/** `also`: SQL run on the copy too — keys of sealed files cleared, say, where the files go readable. */
export async function stripSync(bytes, also = '') {
  const { default: initSqlJs } = await import('sql.js')
  const SQL = await initSqlJs({ locateFile: () => `${import.meta.env.BASE_URL}sql-wasm.wasm` })
  // A server's export is in WAL mode, which an in-memory copy cannot open.
  const db = new SQL.Database(asRollbackFile(new Uint8Array(bytes)))
  const facade = {
    async all(sql, params = []) {
      const stmt = db.prepare(sql)
      try {
        stmt.bind(params)
        const rows = []
        while (stmt.step()) rows.push(stmt.getAsObject())
        return rows
      } finally {
        stmt.free()
      }
    },
    async run(sql, params = []) {
      db.run(sql, params)
    },
    async exec(sql) {
      db.exec(sql)
    },
  }
  try {
    await remove(facade)
    if (also) db.exec(also)
    return db.export()
  } finally {
    db.close()
  }
}
